import { Box, Button, CircularProgress } from "@material-ui/core";
import { useFormik } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import * as Yup from "yup";

import SharedInputField from "../../SharedInputField";
import { phoneRegExp } from '../../../utils/validateReg';
import endUserChatApi from "../../../../api/endUserChatApi";
import "./style.css";
import { useState } from "react";
import { handleCreateChatBox } from "../../../../redux/actions/notLoginEndUserChatActions";
import { useDispatch } from "react-redux";

const initialValues = {
  name: "",
  email: "",
  phone_number: "",
}

const EndUserForm = (props) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const schema = Yup.object().shape({
    name: Yup.string()
      .min(3, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MINIMUM_SYMBOLS",
        })  
      )
      .max(50, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MAXIMUM_SYMBOLS",
        })  
      )
      .required(
        intl.formatMessage({
          id: "CLIENT.GENERAL.REQUIRED_FIELD",
        })
      ),
    email: Yup.string()
      .nullable()
      .email(
        intl.formatMessage({
          id: "CLIENT.GENERAL.INVALID_EMAIL_FORMAT",
        })
      )
      .min(3, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MINIMUM_SYMBOLS",
        })  
      )
      .max(50, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MAXIMUM_SYMBOLS",
        })  
      ),
    phone_number: Yup.string()
      .required(
        intl.formatMessage({
          id: "CLIENT.GENERAL.REQUIRED_FIELD",
        })
      )
      .matches(
        phoneRegExp,
        intl.formatMessage({
          id: "CLIENT.GENERAL.INVALID_PHONE_NUMBER_FORMAT",
        })
      )
      .min(3, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MINIMUM_SYMBOLS",
        })  
      )
      .max(50, 
        intl.formatMessage({
          id: "CLIENT.GENERAL.MAXIMUM_SYMBOLS",
        })  
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        setLoading(true)
        const data = {
          fullName: values.name,
          email: values.email,
          phoneNumber: values.phone_number
        }
        const resp = await endUserChatApi.createToken(data);
        const chatSession = {
          token: resp.token,
          roomChatId: resp.roomChatId,
          roomChatMemberId: resp.roomChatMemberId,
        }
        localStorage.setItem("reeco-chat-session", JSON.stringify(chatSession));
        if (resp.success) {
          dispatch(handleCreateChatBox({
            ...resp
          }))
        }
      } catch (error) {
        console.log(error);
      } finally {
        setSubmitting(false)
        setLoading(false)
      }
    },
  });

  return (
    <div>
      <h3 className="enduser-chat-fill-info">
        <FormattedMessage id="CLIENT.END_USER_CHAT.FILL_INFO" />
      </h3>
      <form onSubmit={formik.handleSubmit}>
        <Box mb={3}>
          <SharedInputField 
            name="name"
            label={intl.formatMessage({ id: 'CLIENT.END_USER_CHAT.FULL_NAME' })}
            type="text"
            placeholder={intl.formatMessage({ id: 'CLIENT.END_USER_CHAT.FULL_NAME_HINT' })}
            {...formik.getFieldProps("name")}
            disabled={formik.isSubmitting}
            required
            errorMsg={formik.touched["name"] && formik.errors["name"]}
          />
        </Box>
        <Box mb={3}>
          <SharedInputField 
            name="email"
            label={intl.formatMessage({ id: 'CLIENT.ORGANIZATION_ACTIONS.EMAIL_LABEL' })}
            type="text"
            placeholder={intl.formatMessage({ id: 'CLIENT.ORGANIZATION_ACTIONS.EMAIL_HINT' })}
            {...formik.getFieldProps("email")}
            disabled={formik.isSubmitting}
            errorMsg={formik.touched["email"] && formik.errors["email"]}
          />
        </Box>
        <Box mb={5}>
          <SharedInputField 
            name="phone_number"
            label={intl.formatMessage({ id: 'CLIENT.ORGANIZATION_ACTIONS.PHONE_NUMBER_LABEL' })}
            type="text"
            placeholder={intl.formatMessage({ id: 'CLIENT.ORGANIZATION_ACTIONS.PHONE_NUMBER_HINT' })}
            {...formik.getFieldProps("phone_number")}
            disabled={formik.isSubmitting}
            required
            errorMsg={formik.touched["phone_number"] && formik.errors["phone_number"]}
          />
        </Box>
        <Box display="flex" alignItems="flex-end" justifyContent="center">
          <Box display="flex" alignItems="center" justifyContent="center">
            <Button
              className="custom-button"
              type="submit"
              disabled={
                formik.isSubmitting ||
                !formik.isValid
              }
            >
              <FormattedMessage id="CLIENT.END_USER_CHAT.START_CONTACT" />
              {loading && <CircularProgress color="inherit" size={16} style={{marginLeft: "5px"}}/>}
            </Button>
          </Box>
        </Box>
      </form>
    </div>
  )
}

export default EndUserForm;